import React, { useEffect, useMemo, useState } from 'react';

import { IUiMultiSelectProps } from '@shared/ui/UiMultiSelect/model/types';

interface IUseCurrentValues {
    onClearValuesCb?: () => void;
    options: IUiMultiSelectProps['options'];
    defaultValues?: IUiMultiSelectProps['defaultValues'];
}

export const useCurrentValues = ({
    onClearValuesCb,
    options,
    defaultValues,
}: IUseCurrentValues) => {
    const [currentValues, setCurrentValues] = useState<string[]>([]);

    useEffect(() => {
        setCurrentValues(defaultValues ?? []);
    }, [currentValues, defaultValues]);

    const clearCurrentValues = (e: React.SyntheticEvent) => {
        e.stopPropagation();
        setCurrentValues([]);
        onClearValuesCb?.();
    };
    const addNewValue = (value: string) => {
        setCurrentValues((prev) => [...prev, value]);
    };
    const filterCurrentValues = (value: string) => {
        setCurrentValues((prev) => prev.filter((item) => item !== value));
    };

    const onItemClick = (value: string) => {
        const findValue = options.find((item) => item.value === value);
        if (currentValues.includes(findValue.label)) {
            filterCurrentValues(findValue.label);
            return;
        }
        addNewValue(findValue.label);
    };

    const currentValuesText = useMemo(() => currentValues.join(', '), [currentValues]);
    const isEmptyValues = currentValues.length === 0;

    return {
        currentValuesText,
        isEmptyValues,
        clearCurrentValues,
        onItemClick,
    };
};
